import React from 'react';

interface DMSSettingsIconProps {
  isActive?: boolean;
}

export const DMSSettingsIcon: React.FC<DMSSettingsIconProps> = ({ isActive = false }) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M89.034 43.825L74.452 27.423c-0.725-0.816-1.767-1.284-2.859-1.284H58.256v-0.448c0-3.723-3.029-6.752-6.751-6.752H6.752C3.029 18.94 0 21.969 0 25.692v35.098c0 2.219 1.805 4.024 4.023 4.024h10.374c0.827 3.573 4.029 6.247 7.85 6.247s7.023-2.674 7.85-6.247h25.193h2.967h10.701c0.827 3.573 4.029 6.247 7.85 6.247s7.023-2.674 7.85-6.247h1.519c2.109 0 3.825-1.715 3.825-3.825V46.367c0-0.937-0.343-1.84-0.966-2.542zM85.213 43.993H67.936c-0.336 0-0.609-0.274-0.609-0.61v-7.785c0-0.336 0.273-0.609 0.609-0.609h9.272L85.213 43.993zM6.752 21.907h44.753c2.086 0 3.784 1.698 3.784 3.785v0.448v22.322H2.967v-22.77c0-2.086 1.698-3.784 3.785-3.784zM22.246 68.093c-2.81 0-5.097-2.286-5.097-5.097s2.287-5.097 5.097-5.097 5.097 2.286 5.097 5.097-2.287 5.097-5.097 5.097zM30.218 61.846c-0.561-3.902-3.917-6.913-7.972-6.913s-7.411 3.011-7.972 6.913H4.023c-0.582 0-1.056-0.474-1.056-1.057v-9.361h52.322v10.417H30.218zM76.807 68.093c-2.811 0-5.097-2.286-5.097-5.097s2.286-5.097 5.097-5.097 5.097 2.286 5.097 5.097-2.286 5.097-5.097 5.097zM86.175 61.846h-1.397c-0.561-3.902-3.917-6.913-7.972-6.913s-7.411 3.011-7.972 6.913H58.256v-32.74h13.337c0.244 0 0.478 0.105 0.641 0.288l2.335 2.627h-6.634c-1.972 0-3.576 1.604-3.576 3.576v7.785c0 1.972 1.604 3.577 3.576 3.577h19.097v14.029c0 0.474-0.384 0.858-0.858 0.858z"
        fill={isActive ? "var(--active-color)" : "#83829D"}
      />
    </svg>
  );
};

